import React, {  useState, useEffect } from 'react';
import {
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
} from "reactstrap";
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
//SimpleBar
import SimpleBar from "simplebar-react";
import { Avatar } from '@mui/material';
import {Chip} from '@mui/material';
import { item_details } from "../../api/requisition";
import { toast } from 'react-toastify';

const StockRightSideBar = ({handleStockClick, mergedArray}) => { 
    // open offcanvas
    const [open, setOpen] = useState(true);

    const toggleLeftCanvas = () => {
        setOpen(!open);
        handleStockClick(!open)
    };

    window.onscroll = function () {
        scrollFunction();
    };

    const scrollFunction = () => {
        const element = document.getElementById("back-to-top");
        if (element) {
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                element.style.display = "block";
            } else {
                element.style.display = "none";
            }
        }
    };

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };


    return (
        <React.Fragment>
            <button
                onClick={() => toTop()}
                className="btn btn-danger btn-icon" id="back-to-top">
                <i className="ri-arrow-up-line"></i>
            </button>

            <div>
                <div className="customizer-setting d-none d-md-block">
                    <div onClick={toggleLeftCanvas} className="btn-info btn-rounded shadow-lg btn btn-icon btn-lg p-2">
                        <i className='mdi mdi-spin mdi-cog-outline fs-22'></i>
                    </div>
                </div>
                <Offcanvas isOpen={open} toggle={toggleLeftCanvas} direction="end" className="offcanvas-end border-0">
                    <OffcanvasHeader  className="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header-dark" toggle={toggleLeftCanvas}>
                        <span className="m-0 me-2 text-white">STOCK IN HAND</span>
                    </OffcanvasHeader>
                    <OffcanvasBody className="p-0">
                        <SimpleBar className="h-100">
                            <div className="p-3 pt-3">
                            <div className="d-flex align-items-center justify-content-between mb-2">
                              <h6 className="mb-0 fw-semibold text-uppercase">{mergedArray.product_name}</h6>
                            </div>
                                <p className="text-muted">{mergedArray.product_code}</p>


                                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                  <tr style={{ borderBottom: '1px solid #E8E8E8',borderTop: '1px solid #E8E8E8' }}>
                                    <td style={{ borderRight: '1px solid #E8E8E8',borderLeft: '1px solid #E8E8E8', padding: '5px', color:'rgb(84, 91, 105)' }}><p className='mb-0'>Location</p></td>
                                    <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px',color:'rgb(84, 91, 105)' }}><p className='mb-0'>Name</p></td>
                                    <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px',color:'rgb(84, 91, 105)' }}><p className='mb-0'>PO Number</p></td>
                                    <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px',color:'rgb(84, 91, 105)' }}><p className='mb-0'>Quantity</p></td>
                                    <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px',color:'rgb(84, 91, 105)' }}><p className='mb-0'>Status</p></td>
                                  </tr>
                                  {mergedArray.stock_records.length>0 && mergedArray.stock_records.map((record, index) => (
                                        <tr key={index}>
                                        <td style={{ border: '1px solid #E8E8E8', padding: '5px' }}>{record.Location}</td>
                                        <td style={{ border: '1px solid #E8E8E8', padding: '5px' }}>{record.Name}</td>
                                        <td style={{ border: '1px solid #E8E8E8', padding: '5px', whiteSpace: 'pre-wrap' }}>{'PoNumber' in record?(
                                                <span>
                                                {record.PoNumber.slice(0, 7)}
                                                <br />
                                                {record.PoNumber.slice(7)}
                                                </span>
                                            ) :'--'}</td>

                                        <td style={{ border: '1px solid #E8E8E8', padding: '5px' }}>{record.Quantity}</td>
                                        <td style={{ border: '1px solid #E8E8E8', padding: '5px' }}>{record.Status}</td>
                                        </tr>
                                    ))}
                                    <tr style={{border:'1px solid #E8E8E8'}}>
                                        <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px' }}>Total Quantity :</td>
                                        <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px' }}></td>
                                        <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px' }}></td>
                                        <td style={{ borderRight: '1px solid #E8E8E8', padding: '5px', textAlign:'center' }}>
                                            {mergedArray.stock_records.reduce((total, record) => total + record.Quantity, 0)}
                                        </td>
                                        <td style={{ borderRight: '1px solid #E8E8E8', padding: '1px' }}></td>
                                    </tr>
                                </table>
                                <br/>                              
                              
                              
                            </div>
                        </SimpleBar>

                    </OffcanvasBody>

                </Offcanvas>
            </div>
        </React.Fragment>
    );
};

export default StockRightSideBar;